(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muskle-creatine-omega-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot() {
      var roots = document.querySelectorAll("[data-co-landing]");
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    function init(root) {
      if (!root || root.getAttribute("data-co-ready") === "1") return;
      if (!root.querySelector("[data-co-config]")) return;
      root.setAttribute("data-co-ready", "1");

      var config = readJson(root, "[data-co-config]");
      var variants = readJson(root, "[data-co-variants]") || [];
      if (!config) return;

      var state = {
        index: 0,
        variant: variants[0] || null,
      };
      var idInputStart = root.querySelector("[data-co-creatine-id]");
      var startId = idInputStart ? Number(idInputStart.value) : 0;
      for (var v = 0; v < variants.length; v++) {
        if (Number(variants[v].id) === startId) {
          state.index = v;
          state.variant = variants[v];
        }
      }

      var endMs = zonedEnd(config.endsAt, config.timeZone || "Europe/Brussels");
      var timerId = 0;
      var lastSpokenMinute = "";

      function tick() {
        var left = endMs - Date.now();
        if (!isFinite(endMs) || left <= 0) {
          expire();
          return;
        }
        root.setAttribute("data-promo", "on");
        var timer = root.querySelector("[data-co-timer]");
        var ended = root.querySelector("[data-co-ended]");
        var label = root.querySelector("[data-co-timer-label]");
        if (timer) timer.hidden = false;
        if (ended) ended.hidden = true;
        if (label) label.hidden = false;
        var total = Math.floor(left / 1000);
        var days = Math.floor(total / 86400);
        var hours = Math.floor((total % 86400) / 3600);
        var minutes = Math.floor((total % 3600) / 60);
        var seconds = total % 60;
        setText(root, "[data-co-days]", pad(days));
        setText(root, "[data-co-hours]", pad(hours));
        setText(root, "[data-co-minutes]", pad(minutes));
        setText(root, "[data-co-seconds]", pad(seconds));
        var spoken = days + ":" + hours + ":" + minutes;
        if (spoken !== lastSpokenMinute) {
          lastSpokenMinute = spoken;
          var live = root.querySelector("[data-co-timer-live]");
          if (live) {
            live.textContent =
              (config.timerLabel || "") +
              " " +
              days +
              " " +
              hours +
              " " +
              minutes;
          }
        }
      }

      function expire() {
        if (timerId) window.clearInterval(timerId);
        root.setAttribute("data-promo", "off");
        var timer = root.querySelector("[data-co-timer]");
        var ended = root.querySelector("[data-co-ended]");
        var label = root.querySelector("[data-co-timer-label]");
        var sub = root.querySelector("[data-co-sub]");
        if (timer) timer.hidden = true;
        if (label) label.hidden = true;
        if (ended) ended.hidden = false;
        if (sub && config.expiredSub) sub.textContent = config.expiredSub;
        paint();
      }

      function paint() {
        var variant = state.variant;
        if (!variant) return;
        var promoOn = root.getAttribute("data-promo") !== "off";
        var percent = Number(config.percent) || 0;
        var creatinePromo = promoCents(variant.price, percent);
        var omegaPromo = promoCents(config.omegaPrice, percent);
        var bundle = Number(variant.price) + Number(config.omegaPrice);
        var bundlePromo = creatinePromo + omegaPromo;
        var idInput = root.querySelector("[data-co-creatine-id]");
        if (idInput) idInput.value = String(variant.id);
        setMoney(root, "[data-co-out='creatine-promo']", creatinePromo, config.moneyFormat);
        setMoney(root, "[data-co-out='creatine-price']", variant.price, config.moneyFormat);
        setCompare(root, "[data-co-out='creatine-compare']", variant.compare, variant.price, config.moneyFormat);
        setMoney(root, "[data-co-out='omega-promo']", omegaPromo, config.moneyFormat);
        setMoney(root, "[data-co-out='omega-price']", config.omegaPrice, config.moneyFormat);
        setCompare(root, "[data-co-out='omega-compare']", config.omegaCompare, config.omegaPrice, config.moneyFormat);
        setMoney(root, "[data-co-out='bundle-price']", bundle, config.moneyFormat);
        setMoney(root, "[data-co-out='bundle-promo']", bundlePromo, config.moneyFormat);
        setMoney(root, "[data-co-out='bundle-save']", Math.max(0, bundle - bundlePromo), config.moneyFormat);
        setMoney(root, "[data-co-out='sticky']", promoOn ? bundlePromo : bundle, config.moneyFormat);
        setText(root, "[data-co-flavor-current]", variant.label || "");
        setText(
          root,
          "[data-co-flavor-name]",
          (config.flavorPrefix || "Smaak") + ": " + (variant.label || "")
        );
        var dots = root.querySelectorAll("[data-co-dot]");
        for (var d = 0; d < dots.length; d++) {
          var on = d === state.index;
          dots[d].classList.toggle("is-selected", on);
          dots[d].setAttribute("aria-pressed", on ? "true" : "false");
        }
        swapImage(root, variant);
        var canBuy = variant.available && config.omegaAvailable !== false;
        var buttons = root.querySelectorAll("[data-co-submit]");
        for (var b = 0; b < buttons.length; b++) {
          if (root.getAttribute("data-co-busy") === "1") continue;
          buttons[b].disabled = !canBuy;
        }
      }

      function showIndex(index) {
        if (!variants.length) return;
        var len = variants.length;
        var next = ((index % len) + len) % len;
        var variant = variants[next];
        if (!variant || variant.available === false) {
          var step = index >= state.index ? 1 : -1;
          if (index === state.index) step = 1;
          for (var hop = 1; hop <= len; hop++) {
            var tryIndex = ((next + step * hop) % len + len) % len;
            if (variants[tryIndex] && variants[tryIndex].available !== false) {
              next = tryIndex;
              variant = variants[tryIndex];
              break;
            }
          }
        }
        state.index = next;
        state.variant = variant;
        paint();
      }

      var prev = root.querySelector("[data-co-prev]");
      var nextBtn = root.querySelector("[data-co-next]");
      if (prev) {
        prev.addEventListener("click", function () {
          showIndex(state.index - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          showIndex(state.index + 1);
        });
      }
      var dotButtons = root.querySelectorAll("[data-co-dot]");
      for (var f = 0; f < dotButtons.length; f++) {
        dotButtons[f].addEventListener("click", function (event) {
          var index = Number(event.currentTarget.getAttribute("data-co-dot"));
          if (!isFinite(index)) return;
          showIndex(index);
        });
      }

      var form = root.querySelector("[data-co-form]");
      if (form) {
        form.addEventListener("submit", function (event) {
          event.preventDefault();
          addBoth(root, config, state);
        });
      }

      detectDiscount(root, config);
      watchSticky(root);
      tick();
      if (root.getAttribute("data-promo") !== "off") {
        timerId = window.setInterval(tick, 1000);
      }
      paint();
    }

    function addBoth(root, config, state) {
      if (root.getAttribute("data-co-busy") === "1") return;
      var variant = state.variant;
      var error = root.querySelector("[data-co-error]");
      if (!variant || !variant.available || config.omegaAvailable === false) {
        if (error) {
          error.hidden = false;
          error.textContent = config.unavailable || "";
        }
        return;
      }
      root.setAttribute("data-co-busy", "1");
      if (error) error.hidden = true;
      var buttons = root.querySelectorAll("[data-co-submit]");
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true;
        buttons[i].textContent = config.busy || "...";
      }

      var sectionIds = [];
      var carts = document.querySelectorAll("cart-items-component");
      for (var c = 0; c < carts.length; c++) {
        if (carts[c].dataset && carts[c].dataset.sectionId) sectionIds.push(carts[c].dataset.sectionId);
      }

      var payload = {
        items: [
          { id: Number(variant.id), quantity: 1 },
          { id: Number(config.omegaId), quantity: 1 },
        ],
      };
      if (sectionIds.length) payload.sections = sectionIds.join(",");

      var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || "/cart/add.js";
      fetch(url, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json().then(function (json) {
            return { ok: response.ok, json: json };
          });
        })
        .then(function (pack) {
          var failed = !pack.ok || (pack.json && pack.json.status);
          if (failed) {
            var message =
              (pack.json && (pack.json.description || pack.json.message)) || config.error;
            if (error) {
              error.hidden = false;
              error.textContent = message;
              if (error.scrollIntoView) error.scrollIntoView({ block: "center" });
            }
            return;
          }
          return fetch("/cart.js", { credentials: "same-origin" })
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent("cart:update", {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    sourceId: "co-landing",
                    data: {
                      source: "product-form-component",
                      itemCount: 2,
                      sections: pack.json && pack.json.sections,
                    },
                  },
                })
              );
              var drawer = document.querySelector("cart-drawer-component");
              if (!drawer && window.Theme && Theme.routes && Theme.routes.cart_url) {
                window.location.href = Theme.routes.cart_url;
              }
            });
        })
        .catch(function () {
          if (error) {
            error.hidden = false;
            error.textContent = config.error || "";
          }
        })
        .then(function () {
          root.removeAttribute("data-co-busy");
          var canBuy = config.omegaAvailable !== false && state.variant && state.variant.available !== false;
          for (var b = 0; b < buttons.length; b++) {
            buttons[b].disabled = !canBuy;
            buttons[b].textContent = config.idle || "";
          }
        });
    }

    function detectDiscount(root, config) {
      var code = String(config.code || "").toUpperCase();
      if (!code) return;
      function show(matched) {
        var note = root.querySelector("[data-co-applied]");
        if (note) note.hidden = !matched;
        var codeLabel = root.querySelector("[data-co-code-label]");
        var codeWrap = root.querySelector("[data-co-code]");
        if (codeLabel) codeLabel.textContent = matched ? config.codeOn || "" : config.codeIdle || "";
        if (codeWrap) codeWrap.classList.toggle("is-on", Boolean(matched));
      }
      var cookieCode = "";
      var crumbs = document.cookie ? document.cookie.split(";") : [];
      for (var i = 0; i < crumbs.length; i++) {
        var bit = crumbs[i].replace(/^\s+/, "");
        if (bit.indexOf("discount_code=") === 0) {
          cookieCode = decodeURIComponent(bit.slice("discount_code=".length));
        }
      }
      if (cookieCode.toUpperCase() === code) {
        show(true);
        return;
      }
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var codes = (cart && cart.discount_codes) || [];
          var matched = false;
          for (var n = 0; n < codes.length; n++) {
            if (String(codes[n].code || "").toUpperCase() === code) matched = true;
          }
          show(matched);
        })
        .catch(function () {});
    }

    function watchSticky(root) {
      var sticky = root.querySelector("[data-co-sticky]");
      var anchors = root.querySelectorAll("[data-co-anchor]");
      if (!sticky || !anchors.length || !("IntersectionObserver" in window)) return;
      var visible = {};
      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            visible[i] = entries[i].isIntersecting;
            entries[i].target.setAttribute("data-co-seen", entries[i].isIntersecting ? "1" : "0");
          }
          var any = false;
          for (var a = 0; a < anchors.length; a++) {
            if (anchors[a].getAttribute("data-co-seen") === "1") any = true;
          }
          var show = !any && window.matchMedia("(max-width: 749px)").matches;
          sticky.hidden = !show;
          root.classList.toggle("co-sticky-on", show);
        },
        { threshold: 0.4 }
      );
      for (var n = 0; n < anchors.length; n++) observer.observe(anchors[n]);
    }

    function swapImage(root, variant) {
      if (!variant || !variant.image) return;
      var frames = root.querySelectorAll("[data-co-creatine-shot] img");
      for (var i = 0; i < frames.length; i++) {
        frames[i].src = variant.image;
        frames[i].removeAttribute("srcset");
        if (variant.alt) frames[i].alt = variant.alt;
      }
    }

    function setMoney(root, selector, cents, format) {
      var nodes = root.querySelectorAll(selector);
      var text = formatMoney(cents, format);
      for (var i = 0; i < nodes.length; i++) nodes[i].textContent = text;
    }

    function setCompare(root, selector, compare, price, format) {
      var node = root.querySelector(selector);
      if (!node) return;
      var show = Number(compare) > Number(price);
      node.hidden = !show;
      if (show) node.textContent = formatMoney(compare, format);
    }

    function setText(root, selector, value) {
      var node = root.querySelector(selector);
      if (node) node.textContent = value;
    }

    function promoCents(cents, percent) {
      var pay = 100 - Number(percent || 0);
      return Math.floor((Number(cents) * pay) / 100);
    }

    function formatMoney(cents, format) {
      var amount = (Number(cents) / 100).toFixed(2);
      var parts = amount.split(".");
      var comma = parts[0] + "," + parts[1];
      var dotThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + parts[1];
      var commaThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + parts[1];
      var apostrophe = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + "." + parts[1];
      var noDecimals = String(Math.round(Number(cents) / 100));
      var template = format || "€{{amount}}";
      return template
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dotThousands)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "."))
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, apostrophe)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ") + "," + parts[1])
        .replace(/\{\{\s*amount\s*\}\}/g, commaThousands)
        .replace(/\{\{\s*amount_with_comma\s*\}\}/g, comma);
    }

    function zonedEnd(localIso, timeZone) {
      var match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/.exec(String(localIso || ""));
      if (!match) return NaN;
      var y = Number(match[1]);
      var mo = Number(match[2]);
      var d = Number(match[3]);
      var h = Number(match[4]);
      var mi = Number(match[5]);
      var s = Number(match[6]);
      var utc = Date.UTC(y, mo - 1, d, h, mi, s);
      var fmt = new Intl.DateTimeFormat("en-US", {
        timeZone: timeZone,
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
      function asUtc(date) {
        var map = {};
        var parts = fmt.formatToParts(date);
        for (var i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;
        var hour = Number(map.hour) % 24;
        return Date.UTC(Number(map.year), Number(map.month) - 1, Number(map.day), hour, Number(map.minute), Number(map.second));
      }
      var offset = asUtc(new Date(utc)) - utc;
      var target = utc - offset;
      var offset2 = asUtc(new Date(target)) - target;
      if (offset2 !== offset) target = utc - offset2;
      return target;
    }

    function pad(value) {
      return value < 10 ? "0" + value : String(value);
    }

    function readJson(root, selector) {
      var node = root.querySelector(selector);
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
